<div>
  <div class="content-container">
    <nav class="navbar navbar-brand bg-body-tertiary">
      <div class="container-fluid">
        <img class="btm-logo navbar-left navbar-brand" src="assets/images/cibmtr_logo.png" alt="CIBMTR Logo" />
        <div class="flex-row buttons">
          <button class="logout-button"  (click)="closeDialog('logout')">Logout</button>
        </div>
      </div>
    </nav>
  </div>
  <br/>
  <div class="selectionDiv">
    <div class="container-fluid">
      <div class="panel-ms">
        <span class="selectiontext">Import Patient to MatchSource<sup>&reg;</sup></span>
        <br/>
        <span>Create a patient with NMDP directly from your electronic health record. An in-progress patient in MatchSource will be created.</span>
        <br/>
        <button mat-button class="button-ms" (click)="closeDialog('msync')">Import Patient</button>
      </div>
    </div>

     <div class="container-fluid">
        <div class="panel-cra">
          <span class="selectiontext">Launch CIBMTR<sup>&reg;</sup> Application</span>
          <br/>
          <span>Register patients with CIBMTR. Display and send data from your electronic health records to populate data for CIBMTR reporting.</span>
          <br/>
          <button mat-button class="button-cr" (click)="closeDialog('cra')">CIBMTR<sup>&reg;</sup> Reporting</button>
        </div>
     </div>
  </div>
</div>
